import type { FloorPlan } from './types';

const keyFor = (id: string) => `rehub-floorplan-draft-v1:${id}`;

export interface FloorPlanDraft {
  name: string;
  canvas_data: unknown;
  savedAt: string;
}

export function writeFloorPlanDraft(id: string, draft: FloorPlanDraft): void {
  try {
    localStorage.setItem(keyFor(id), JSON.stringify(draft));
  } catch {
    // Private mode or a full disk — the in-memory plan still saves to the server.
  }
}

export function clearFloorPlanDraft(id: string): void {
  try {
    localStorage.removeItem(keyFor(id));
  } catch {
    // Ignore storage failures.
  }
}

export function readFloorPlanDraft(id: string): FloorPlanDraft | null {
  try {
    const raw = localStorage.getItem(keyFor(id));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FloorPlanDraft;
    if (!parsed || typeof parsed.savedAt !== 'string' || !('canvas_data' in parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** Prefer a newer on-device copy when the tab was closed before the server save finished. */
export function mergeFloorPlanDraft(fp: FloorPlan): { plan: FloorPlan; restored: boolean } {
  const draft = readFloorPlanDraft(fp.id);
  if (!draft) return { plan: fp, restored: false };
  const draftTime = Date.parse(draft.savedAt);
  const serverTime = Date.parse(fp.updated_at);
  if (!Number.isFinite(draftTime) || draftTime <= serverTime) return { plan: fp, restored: false };
  return {
    restored: true,
    plan: {
      ...fp,
      name: draft.name || fp.name,
      canvas_data: draft.canvas_data,
      updated_at: draft.savedAt,
    },
  };
}
